import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";
import ReportItemPacingDiamond from "Reporting/Components/ReportItemPacingDiamond";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";

export default function ReportTablePacingDiamond({
  report,
  onSortedRowsChange,
}) {
  const [sortDirection, setSortDirection] = useState(null);

  const rows = useMemo(() => {
    const reportRows = Array.isArray(report?.rows) ? [...report.rows] : [];
    const totalRows = reportRows.filter((row) => row.isTotalRow);
    const dataRows = reportRows.filter((row) => !row.isTotalRow);

    if (sortDirection) {
      dataRows.sort((a, b) => {
        const difference =
          Number(a.percentOfChange || 0) - Number(b.percentOfChange || 0);
        return sortDirection === "asc" ? difference : -difference;
      });
    }

    return [...totalRows, ...dataRows];
  }, [report?.rows, sortDirection]);

  const togglePercentSort = () => {
    setSortDirection((current) => {
      if (current === null) return "asc";
      if (current === "asc") return "desc";
      return null;
    });
  };

  const renderPercentSortIcon = () => {
    const icon =
      sortDirection === "asc"
        ? faChevronUp
        : sortDirection === "desc"
        ? faChevronDown
        : faMinus;

    return <FontAwesomeIcon icon={icon} className={styles.sortIcon} />;
  };

  useEffect(() => {
    onSortedRowsChange?.(rows);
  }, [rows, onSortedRowsChange]);

  const showEventInfo =
    report.currentEvent !== "- All Events -" &&
    report.priorEvent !== "- All Events -";

  return (
    <div>
      <div className={styles.headerInfo}>
        <div className={styles.title}>
          <div className={styles.eventTitle}>{report.reportTitle}</div>
          {showEventInfo && (
            <div className={styles.eventInfo}>
              <div>Current Event: {report.currentEvent}</div>
              <div>Prior Event: {report.priorEvent}</div>
            </div>
          )}
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.asOf}>As Of</div>
          <div className={styles.diamond}>Diamond</div>
          <div className={styles.currentComp}>Current Comp</div>
          <div className={styles.currentPaid}>Current Paid</div>
          <div className={styles.currentTotal}>Current Total</div>
          <div className={styles.priorComp}>Prior Comp</div>
          <div className={styles.priorPaid}>Prior Paid</div>
          <div className={styles.priorTotal}>Prior Total</div>
          <div className={styles.percentOfChange} onClick={togglePercentSort}>
            % Change
            {renderPercentSortIcon()}
          </div>
        </div>

        {rows.map((row, index) => (
          <div className={styles.pageRowWrapper} key={index}>
            <ReportItemPacingDiamond item={row} isOdd={index % 2 !== 0} />
          </div>
        ))}
      </div>
    </div>
  );
}

ReportTablePacingDiamond.propTypes = {
  report: PropTypes.shape({
    currentEvent: PropTypes.string,
    priorEvent: PropTypes.string,
    reportTitle: PropTypes.string,
    rows: PropTypes.array,
  }),
  onSortedRowsChange: PropTypes.func,
};
